function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "_clipPath_x6B8XtVFsqEXMTbKLJnklOO4RMtVo2N8"
}, /*#__PURE__*/React.createElement("rect", {
  x: 526,
  y: 361,
  width: 91.9,
  height: 91.8
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#_clipPath_x6B8XtVFsqEXMTbKLJnklOO4RMtVo2N8)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: " M 606.4 361 L 537.6 361 C 531.3 361 526.1 366.2 526.1 372.5 L 526.1 441.3 C 526.1 447.6 531.3 452.8 537.6 452.8 L 606.4 452.8 C 612.7 452.8 617.9 447.6 617.9 441.3 L 617.9 372.5 C 617.9 366.2 612.9 361 606.4 361 Z ",
  fill: "rgb(228,68,50)"
}), /*#__PURE__*/React.createElement("path", {
  d: " M 545.7 404 C 547.4 403.2 582 383.1 582.8 382.7 C 583.6 382.3 583.6 380.8 582.8 380.4 C 582 380 580.3 378.9 579.7 378.5 C 579.1 378.1 577.8 377.9 576.8 378.5 C 576.4 378.7 546.8 395.8 545.7 396.4 C 544.4 397 543 397 541.9 396.4 C 541.1 395.8 526.3 387.2 526.3 387.2 L 526.3 394.9 C 530.1 397.2 539.6 402.6 541.9 403.9 C 543.2 404.8 544.5 404.8 545.7 404 Z ",
  fill: "rgb(255,255,255)"
}), /*#__PURE__*/React.createElement("path", {
  d: " M 545.7 419.4 C 547.4 418.6 582 398.5 582.8 398.1 C 583.6 397.7 583.6 396.2 582.8 395.8 C 582 395.4 580.3 394.3 579.7 393.9 C 579.1 393.5 577.8 393.3 576.8 393.9 C 576.4 394.1 546.8 411.2 545.7 411.8 C 544.4 412.4 543 412.4 541.9 411.8 C 540.9 411.2 526 402.6 526 402.6 L 526 410.3 C 529.8 412.6 539.3 418 541.6 419.3 C 543.2 420.2 544.5 420.2 545.7 419.4 Z ",
  fill: "rgb(255,255,255)"
}), /*#__PURE__*/React.createElement("path", {
  d: " M 545.7 434.8 C 547.4 434 582 413.9 582.8 413.5 C 583.6 413.1 583.6 411.6 582.8 411.2 C 582 410.8 580.3 409.7 579.7 409.3 C 579.1 408.9 577.8 408.7 576.8 409.3 C 576.4 409.5 546.8 426.6 545.7 427.2 C 544.4 427.8 543 427.8 541.9 427.2 C 541.1 426.6 526.3 418 526.3 418 L 526.3 425.7 C 530.1 428 539.6 433.4 541.9 434.7 C 543.2 435.7 544.5 435.7 545.7 434.8 Z ",
  fill: "rgb(255,255,255)"
})));

function SvgTodoistIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "526 361 91.9 91.8",
    width: "91.9pt",
    height: "91.8pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodoistIcon);
export default __webpack_public_path__ + "static/media/todoist-icon.083b20d3.svg";
export { ForwardRef as ReactComponent };